import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import axiosBackEnd from "../../config/axios/axios-back-end";
import moment from "moment";

import { SearchOutlined } from "@ant-design/icons";

import {
  Table,
  Input,
  Button,
  Popconfirm,
  Tag,
  Collapse,
  Form,
  DatePicker,
} from "antd";

import Breadcrumb from "../../components/Breadcrumb";
import FormOne from "../../components/Statistics/AppClickedStatistics/FormOne";
import TableOne from "../../components/Statistics/AppClickedStatistics/TableOne";
import StatisticsUI1 from "../../components/Statistics/AppClickedStatistics/StatisticsUI1";

const { Panel } = Collapse;
const { RangePicker } = DatePicker;
// const data = this.props.api.userGetData;

class PmsManager extends Component {
  state = {
    tableOneData: null,
    statisticsData2: null,
    statisticsData3: null,
  };

  async componentDidMount() {
    if (!this.props.api.hmgMainGetData) {
      await this.props.hmgMainGet();
    }
    if (!this.props.api.hmgGetData) {
      await this.props.hmgGet();
    }
    if (!this.props.api.hotelGetData) {
      await this.props.hotelGet();
    }
  }

  formOneOnFinish = async (data) => {
    this.props.apiStart();
    try {
      // const res = await axiosBackEnd.post("/api/file-upload", fmData, config);
      const headers = {
        "Content-Type": "application/json",
      };

      // const response = await axiosBackEnd.get("/api/statistics", { params: send_data, headers: headers });
      const response = await axiosBackEnd.post("/api/statistics", data, {
        headers: headers,
      });

      if (response && response.data && response.data.data) {
        this.setState({ tableOneData: response.data.data });
      }
      if (response && response.data && response.data.data_2) {
        this.setState({ statisticsData2: response.data.data_2 });
      }
      if (response && response.data && response.data.data_3) {
        this.setState({ statisticsData3: response.data.data_3 });
      }

      this.props.apiComplete();
      // console.log("server res: ", res);
    } catch (err) {
      this.props.apiComplete();
      console.log("Eroor: ", err);
    }
  };

  render() {
    return (
      <div>
        <div className="container_aa">
          <h3>App Clicked Statistics</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "/statistics/app-clicked-statistics",
                breadcrumbName: "App Clicked Statistics",
              },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_1">
            {this.props.api.hmgMainGetData &&
            this.props.api.hmgGetData &&
            this.props.api.hotelGetData ? (
              <FormOne
                formOneOnFinish={this.formOneOnFinish}
                hmgMainGetData={this.props.api.hmgMainGetData.data}
                hmgGetData={this.props.api.hmgGetData.data}
                hotelGetData={this.props.api.hotelGetData.data}
              />
            ) : null}

            {this.state.statisticsData2 &&
            this.state.statisticsData2.length > 0 ? (
              <StatisticsUI1
                name="Dashboard App Click Statistics"
                statisticsData2={this.state.statisticsData2}
              />
            ) : null}

            {this.state.statisticsData3 &&
            this.state.statisticsData3.length > 0 ? (
              <StatisticsUI1
                name="Dashboard Portal Click Statistics"
                statisticsData2={this.state.statisticsData3}
              />
            ) : null}

            {this.state.tableOneData ? (
              <TableOne tableOneData={this.state.tableOneData} />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hmgMainGet: () => dispatch(actions.hmgMainGet()),
  hmgGet: () => dispatch(actions.hmgGet()),
  hotelGet: () => dispatch(actions.hotelGet()),
  apiStart: (data) => dispatch(actions.apiStart(data)),
  apiComplete: (data) => dispatch(actions.apiComplete(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PmsManager);
